import { connect } from 'react-redux'
import { flatMapUnique } from 'Services/GraphFilterUtils'
import { Badge, Tooltip, Tabs, Statistic, Layout, Checkbox, Divider, Input, Row, Col, Select } from 'antd'
import { GraphFilterGraphs, GraphFilterTypes, GraphFilterRelations } from 'Components'
import NodeSizeParamsSelector from './NodeSizeParamsSelector'
import RelationSizeParamsSelector from './RelationSizeParamsSelector'
import { setActiveFilterTab } from 'Actions/graphFilter'
import Feather from '@sysunite/react-feather'
import { store } from '~/Store'

{ Search } = Input
{ TabPane } = Tabs

checkBoxItems = [{
  key: 'colorByGraph'
  label: 'Color by graph'
  save: true
}, {
  key: 'shouldHideOnFilter',
  label: 'Freeze element locations'
  save: true
}, {
  key: 'showRelationsAsNodes'
  label: 'Show relations as nodes'
  save: true
  isHiddenForAbstractViews: true
}, {
  key: 'hideRelationLabels'
  label: 'Hide relation labels'
  save: true
}]

graphSizingOptionsItems = [
  {
    label: "Size nodes based on attribute"
    key: 'sizeNodesByAttribute'
    Component: NodeSizeParamsSelector
  },
  {
    label: "Size relations based on attribute"
    key: 'sizeRelationsByAttribute'
    Component: RelationSizeParamsSelector
  }
]

tabs = [{
  key: 'relations'
  title: 'Relations'
  icon: 'git-branch'
  Component: GraphFilterRelations
}, {
  key: 'types'
  title: 'Types'
  icon: 'circle'
  Component: GraphFilterTypes
}, {
  key: 'graphs'
  title: 'Graphs'
  icon: 'disc'
  Component: GraphFilterGraphs
}]

class GraphFilterPanel extends React.Component

  constructor: (props) ->
    super(props)
    @state = checkBoxItems.reduce((acc, { save, key }) ->
      if save
        { acc..., [key]: localStorage.getItem(key) is 'true' }
      else
        acc
    , {})

  renderCheckboxItem = ({ key, label }) ->
    { onChangeFilter } = @props
    <Row key={key}>
      <Checkbox
        onChange={({ target: { checked }}) ->
          localStorage.setItem(key, checked)
          onChangeFilter(key, checked)
        }
        defaultChecked={@state[key]}
      >
        { label }
      </Checkbox>
    </Row>

  renderGraphSizingOptionsItem = ({ label, key, Component }) ->
    <div key={key}>
      <div style={{ padding: "0px 12px" }}>
        <b>{ label }</b>
      </div>
      <Component
        updateConfigNode={false}
      />
    </div>

  omitAndCount: _.flow(_.omit, _.size)

  onChangeTab: (activeKey) =>
    @props.setActiveFilterTab(activeKey)

  filterIsActive: (filters) ->
    _.filter(filters, (filter) -> not filter.enabled).length > 0

  render: ->
    { switchEnabled } = @state
    {
      activeFilterTab
      relationFilters
      typeFilters
      filteredNodes
      filteredRelations
      graphFilters
      nodes
      edges
      abstract
      relNodes
      showRelationsAsNodes
      isVisible
    } = @props

    activeFilters = {
      graphs: @filterIsActive(graphFilters)
      relations: @filterIsActive(relationFilters)
      types: @filterIsActive(typeFilters)
    }

    nodesToHide = flatMapUnique(filteredNodes)
    relationsToHide = flatMapUnique(filteredRelations)

    if showRelationsAsNodes
      nodeCount = @omitAndCount(nodes, [nodesToHide..., _.keys(relNodes)...])
      relationCount = @omitAndCount(edges, relationsToHide) - _.size(_.without(_.keys(relNodes), relationsToHide...))
    else
      nodeCount = @omitAndCount(nodes, nodesToHide)
      relationCount = @omitAndCount(edges, relationsToHide)

    <div className="filter-panel">
      <Tabs
        onChange={@onChangeTab}
        style={{ display: 'flex', flexDirection: 'column', flex: '1 1 auto' }}
        defaultActiveKey={activeFilterTab}>
        {
          tabs.map(({ key, title, icon, Component }) ->
            <TabPane
              tab={
                <Tooltip trigger='hover'
                        title={title}>
                  <Badge dot={activeFilters[key]}>
                    <Feather type={icon} />
                  </Badge>
                </Tooltip>
              }
              key={key}
              style={{ position: 'relative' }}
            >
              <Component />
            </TabPane>
          )
        }
      </Tabs>
      <Divider />
        {
          checkBoxItems
            .filter(({ isHiddenForAbstractViews }) ->
              if isHiddenForAbstractViews
                !abstract
              else
                true
            ).map(renderCheckboxItem.bind(@))
        }
      <Divider />
        {
          graphSizingOptionsItems.map((item) ->
            renderGraphSizingOptionsItem(item)
          )
        }
      <Divider />
      <Row style={{ textAlign: 'center' }} type="flex">
        <Col style={{ flex: 'auto' }}>
          <Statistic title="Relations" value={relationCount} />
        </Col>
        <Col style={{ flex: 'auto' }}>
          <Statistic title="Nodes" value={nodeCount} />
        </Col>
      </Row>
    </div>

export default connect(
  ({
    explore: { nodeSizeParam }
    graphFilter: {
      activeFilterTab,
      relationFilters,
      typeFilters,
      filteredNodes,
      filteredRelations,
      graphFilters,
      showRelationsAsNodes
    },
    graph: { graphData: { nodes, edges, relNodes, abstract }}
  }) ->
    {
      activeFilterTab,
      relationFilters,
      typeFilters,
      filteredNodes,
      filteredRelations,
      nodes,
      edges,
      relNodes,
      abstract,
      graphFilters,
      showRelationsAsNodes,
    }
, { setActiveFilterTab }
)(GraphFilterPanel)
